"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _utils = require("../utils");

var _utils2 = require("../../../Categories/utils");

var _FilterBlock = _interopRequireDefault(require("./FilterBlock"));

var _FilterItem = _interopRequireDefault(require("./FilterItem"));

var _classnames = _interopRequireDefault(require("classnames"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ContentCategoryFilter = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ContentCategoryFilter, _Component);

  var _super = _createSuper(ContentCategoryFilter);

  function ContentCategoryFilter() {
    var _this;

    (0, _classCallCheck2.default)(this, ContentCategoryFilter);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      currentCategory: 0,
      expandedCategories: (0, _toConsumableArray2.default)(new Set((0, _utils2.pathToGivenCategory)(_this.props.categories, _this.state.currentCategory)))
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleCategory", function (categoryId) {
      _this.setState(function (prevState) {
        var expandedCategoryIds = new Set(prevState.expandedCategories);

        if (expandedCategoryIds.has(categoryId)) {
          expandedCategoryIds.delete(categoryId);
          return {
            expandedCategories: Array.from(expandedCategoryIds)
          };
        }

        expandedCategoryIds.add(categoryId);
        return {
          expandedCategories: Array.from(expandedCategoryIds)
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleCategorySelect", function (category) {
      var onCategorySelect = _this.props.onCategorySelect;

      if (category) {
        var _categoryFilterValue = (0, _utils.getNonContainerCategoryIds)(category);

        _this.setState({
          currentCategory: category.id
        });

        onCategorySelect(_categoryFilterValue);
      } else {
        _this.setState({
          currentCategory: 0
        });

        onCategorySelect([]);
      }
    });
    return _this;
  }

  (0, _createClass2.default)(ContentCategoryFilter, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var categories = this.props.categories;
      var _this$state = this.state,
          expandedCategories = _this$state.expandedCategories,
          currentCategory = _this$state.currentCategory;
      var pathToCategory = (0, _utils2.pathToGivenCategory)(categories, currentCategory);
      return (0, _preact.h)("div", {
        className: "category-sidebar-navigation"
      }, (0, _preact.h)("div", {
        className: "category-sidebar-navigation__parent-wrapper",
        key: "category-id-all"
      }, (0, _preact.h)("div", {
        className: "category-sidebar-navigation__header"
      }, (0, _preact.h)("div", {
        className: (0, _classnames.default)('categories-navigation-link', 'categories-navigation-link--top-level', {
          'categories-navigation-link--current': currentCategory === 0
        }),
        onClick: function onClick() {
          return _this2.handleCategorySelect(null);
        },
        role: "button",
        tabIndex: 0,
        onKeyUp: function onKeyUp(e) {
          if (e.code === 'Enter') {
            _this2.handleCategorySelect(null);
          }
        }
      }, (0, _preact.h)(_phrase.default, {
        p: "category_filter.show.all"
      })))), categories.map(function (category) {
        var categoryId = category.id,
            title = category.title,
            children = category.children;
        var isCurrent = currentCategory === categoryId;
        var isExpanded = expandedCategories.includes(categoryId);
        var hasChildren = Boolean(children.length);
        return (0, _preact.h)("div", {
          className: "category-sidebar-navigation__parent-wrapper",
          key: "category-id-".concat(categoryId)
        }, (0, _preact.h)("div", {
          className: "category-sidebar-navigation__header"
        }, (0, _preact.h)(_FilterItem.default, {
          isCurrent: isCurrent,
          topLevel: true,
          toggleCategory: _this2.toggleCategory,
          categoryId: categoryId,
          isExpanded: isExpanded,
          hasChildren: hasChildren,
          onSelect: function onSelect() {
            return _this2.handleCategorySelect(category);
          }
        }, title)), hasChildren && expandedCategories.includes(categoryId) && (0, _preact.h)(_FilterBlock.default, {
          categories: children,
          currentCategory: currentCategory,
          pathToCategory: pathToCategory,
          showBorder: true,
          expandedCategories: expandedCategories,
          toggleCategory: _this2.toggleCategory,
          onCategorySelect: _this2.handleCategorySelect
        }));
      }));
    }
  }]);
  return ContentCategoryFilter;
}(_preact.Component);

var _default = ContentCategoryFilter;
exports.default = _default;